import { useEffect } from 'react';

import { ILesson } from '@/interfaces/lesson';

import * as intercom from './scripts/intercom';
import * as jivo from './scripts/jivo';
import * as live from './scripts/live';
import * as tawkto from './scripts/tawkto';
import * as zendesk from './scripts/zendesk';
import * as zopim from './scripts/zopim';

const ChatHandler = (props: { chats: ILesson['chats'] }) => {
  useEffect(() => {
    const scripts = [
      jivo.register(props.chats),
      live.register(props.chats),
      tawkto.register(props.chats),
      zendesk.register(props.chats),
      zopim.register(props.chats)
    ];

    scripts.forEach(script => {
      if (!script) {
        return;
      }

      script.id = script.id ? script.id : 'chat-script';
      document.body.append(script);
    });

    return () => {
      document.querySelectorAll('#chat-script').forEach(script => {
        script.remove();
      });

      intercom.unregister(props.chats);
      jivo.unregister(props.chats);
      live.unregister(props.chats);
      tawkto.unregister(props.chats);
      zendesk.unregister(props.chats);
      zopim.unregister(props.chats);
    };
  }, [props.chats]);
  return <></>;
};

export default ChatHandler;
